/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/zipCodeFilter.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoZipCodeField implements angular.IDirective {
        private filter: angular.IFilterService;
        private appSettings: Meevo.Components.Common.IAppSettings;

        restrict = "E";
        require = "^ngModel";

        scope = {
            currentZipValue: "=ngModel",
            contentKey: "@",
            disabled: "=ngDisabled",
            required: "=ngRequired",
            change: "&ngChange",
            tabIndex: "=?",
            zipLength: "="
        };

        template = 
`<div>
    <div class="meevo_input_wrapper">
        <label translate="{{contentKey}}" aria-label='{{ contentKey | translate }}'></label>
        <div style="display: inline-block;" ng-class="{'required_red_bubble' : (required && !currentZipValue) || !isValid}"></div>
    </div>
    <input  ng-class="{'red_border_invalid' : (required && !currentZipValue) || !isValid }" 
            type="text" name="{{name}}" 
            ng-model="maskedValue" 
            ng-model-options="{'updateOn': 'default blur','debounce': {'default': 250,'blur': 0}}" 
            ng-disabled="disabled" 
            ng-required="required" aria-label='{{ contentKey | translate }}' title='{{ contentKey | translate }}'
            tabindex="{{tabIndex || 0}}" 
            autocomplete='off'/>
</div>`;

        constructor($filter: angular.IFilterService, appSettings: Meevo.Components.Common.IAppSettings) {
            this.filter = $filter;
            this.appSettings = appSettings;

        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes, ngModel: any) => {
            var filter = this.filter;
            scope.isValid = true;
            scope.maskedValue = scope.currentZipValue || scope.maskedValue;

            var getCountry = (): string => {
                let data = scope.$parent.addressData;
                let country = 'OTHER';
                if (Model.Guard.isSomething(data) && data.country !== 'OTHER') {
                    let hasCountry = Model.Guard.isSomething(data) ? _.has(data, 'country') : false;
                    country = hasCountry ? data.country : this.appSettings.APP_COUNTRYID.substr(3).toUpperCase();
                }
                return country;
            }

            scope.$watch('currentZipValue', newValue => {
                scope.maskedValue = newValue;
                if (!!newValue && angular.isFunction(scope.change))
                    scope.change();
            });

            scope.$watch('maskedValue', maskedVal => {
                let newUnmaskedVal = (maskedVal || '').toUpperCase();
                if (scope.currentZipValue !== newUnmaskedVal) {
                    scope.maskedValue = newUnmaskedVal;
                    scope.currentZipValue = newUnmaskedVal;
                }
            });

            element.on("click", (event: JQueryEventObject) => {
                if (!scope.isDisabled) {
                    let target: any = event.target || event.srcElement;
                    if (target.id === scope.id) {
                        target.select();
                    }
                    event.preventDefault();
                }
            });

            element.on("keydown", (event: JQueryEventObject) => {
                if (_.contains([46, 8, 9, 27, 13, 110, 190], event.keyCode) ||
                    // Allow: Ctrl+A
                    (event.keyCode === 65 && event.ctrlKey) ||
                    // Allow: Ctrl+C
                    (event.keyCode === 67 && event.ctrlKey) ||
                    // Allow: Ctrl+X
                    (event.keyCode === 88 && event.ctrlKey) ||
                    // Allow: home, end, left, right
                    (event.keyCode >= 35 && event.keyCode <= 39)) {
                    // let it happen, don't do anything
                    return;
                }

                return true;
            });

            ngModel.$validators.warning = (modelValue: any, viewValue: any) => {
                if (scope.$parent.addressData) {
                    let valueToTest = modelValue || viewValue;
                    let country = getCountry();
                    if (country && valueToTest) {
                        let defaultRegExp = new RegExp(this.appSettings.APP_COUNTRIES[country]['PostalCodeRegEx']);
                        scope.$parent.addressData.city = defaultRegExp.test(valueToTest) ? scope.$parent.addressData.city : '';
                        scope.isValid = valueToTest.length === 0 || defaultRegExp.test(valueToTest);
                        return scope.isValid;
                    } else {
                        scope.isValid = true;
                        return true;
                    }
                } else {
                    scope.isValid = true;
                    return true;
                }
            }
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($filter: angular.IFilterService, appSettings: Meevo.Components.Common.IAppSettings) => {
                return new MeevoZipCodeField($filter, appSettings);
            };

            directive.$inject = ["$filter", "meevo.AppSettings"];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoZipCodeField", MeevoZipCodeField.factory());
}